import styled from 'styled-components';

const Emoji = (props: { code: number }): JSX.Element => <div {...props}>{String.fromCodePoint(props.code)}</div>;

export default styled(Emoji)``;
